import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import clientService from '../services/clientService';
import ClientForm from '../components/ClientForm';
import { useNotification } from '../context/NotificationContext';
import '../styles/general.css';
import '../styles/clients.css';

const ClientFormPage = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const { notify } = useNotification();
  const isEditMode = !!id;

  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(isEditMode);

  useEffect(() => {
    if (isEditMode) {
      const fetchClient = async () => {
        try {
          const res = await clientService.getClientById(id);
          setClient(res.data);
        } catch (err) {
          notify.error(t('common.failedToLoad'));
        } finally {
          setLoading(false);
        }
      };
      fetchClient();
    }
  }, [id, isEditMode, t, notify]);

  const handleSuccess = () => {
    setTimeout(() => navigate('/clients'), 2000);
  };

  if (loading) {
    return (
      <div className="loading">
        {t('common.loading')}
      </div>
    );
  }

  return (
    <div className="page-container">
      <h1>
        {isEditMode ? t('clients.editTitle') : t('clients.createTitle')}
      </h1>

      <ClientForm
        initialData={client}
        onSuccess={handleSuccess}
        onCancel={() => navigate('/clients')}
      />
    </div>
  );
};

export default ClientFormPage;
